module.exports = __webpack_public_path__ + "static/img/Geos-2022-Yulibeth-.3b7c143.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Geos-2022-Yulibeth-.png
// module id = cTC+
// module chunks = 0